export const CUSTOM_WIDTH_ROLL_CALCULATOR_URL = '/custom-width-roll';
export const CUSTOM_SHORT_LENGTH_CALCULATOR_URL = '/custom-short-length';
export const CUSTOM_CUT_SHAPES_CALCULATOR_URL = '/custom-cut-shapes';
export const ABRASIVE_BELT_CALCULATOR_URL = '/abrasive-calculator';
